var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-input",class:{
    'code-input--complete': _vm.isComplete,
    'code-input--error': _vm.error,
    'code-input--disabled': _vm.disabled,
    'code-input--loading': _vm.loading,
  }},_vm._l((_vm.digits),function(digit,index){return _c('input',{key:index,ref:"inputs",refInFor:true,staticClass:"code-input__digit",style:({ '--index': index }),attrs:{"type":"text","inputmode":"numeric","autocomplete":"one-time-code","maxlength":"2","disabled":_vm.disabled},domProps:{"value":digit},on:{"input":function($event){return _vm.handleInput($event, index)},"keydown":function($event){return _vm.handleKeydown($event, index)},"paste":_vm.handlePaste,"focus":_vm.handleFocus}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754f89c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/code-input/code-input.vue
// module id = e9QU
// module chunks = 0